<template>
</template>

<script>
export default {
  name: '',
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
</style>
